"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.map");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.keys");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mixer = void 0;

var _speaker_track = require("./speaker_track");

var _playlist = require("./playlist");

var _utils = require("./utils");

var _assetPool = require("./assetPool");

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Mixer = /*#__PURE__*/function () {
  function Mixer(_ref) {
    var client = _ref.client,
        windowScope = _ref.windowScope,
        listenerLocation = _ref.listenerLocation,
        _ref$filters = _ref.filters,
        filters = _ref$filters === void 0 ? [] : _ref$filters,
        _ref$sortMethods = _ref.sortMethods,
        sortMethods = _ref$sortMethods === void 0 ? [] : _ref$sortMethods,
        _ref$mixParams = _ref.mixParams,
        mixParams = _ref$mixParams === void 0 ? {} : _ref$mixParams;

    _classCallCheck(this, Mixer);

    var audioContext = (0, _utils.buildAudioContext)(windowScope);
    var selectTrackId = (0, _utils.getUrlParam)(windowScope.location, 'rwfSelectTrackId');
    var audioTracks = client.audiotracks();

    if (selectTrackId) {
      selectTrackId = Number(selectTrackId);
      audioTracks = audioTracks.filter(function (t) {
        return t.id === selectTrackId;
      });
      console.info("isolating track #".concat(selectTrackId));
    }

    var assets = client.assets();
    var timedAssets = client.timedAssets();
    var speakers = client.speakers();
    var listenerPoint = (0, _utils.coordsToPoints)(listenerLocation);
    var assetPool = new _assetPool.AssetPool({
      assets: assets,
      timedAssets: timedAssets,
      filters: filters,
      sortMethods: sortMethods,
      mixParams: mixParams
    });
    this.audioContext = audioContext;
    this.playlist = new _playlist.Playlist({
      audioTracks: audioTracks,
      listenerPoint: listenerPoint,
      assetPool: assetPool,
      audioContext: audioContext,
      windowScope: windowScope
    });
    this.speakerTracks = speakers.map(function (speakerData) {
      return new _speaker_track.SpeakerTrack({
        audioContext: audioContext,
        listenerPoint: listenerPoint,
        data: speakerData
      });
    });
    this.playing = false;
  }

  _createClass(Mixer, [{
    key: "updateParams",
    value: function updateParams(_ref2) {
      var listenerLocation = _ref2.listenerLocation,
          params = _objectWithoutProperties(_ref2, ["listenerLocation"]);

      if (listenerLocation) {
        params.listenerPoint = (0, _utils.coordsToPoints)(listenerLocation);
      }

      this.playlist.updateParams(params);
      this.speakerTracks.forEach(function (t) {
        return t.updateParams(params);
      });
    }
  }, {
    key: "skipTrack",
    value: function skipTrack(trackId) {
      if (this.playlist) this.playlist.skip(trackId);
    }
  }, {
    key: "replayTrack",
    value: function replayTrack(trackId) {
      if (this.playlist) this.playlist.replay(trackId);
    }
  }, {
    key: "toString",
    value: function toString() {
      return 'Roundware Mixer';
    }
  }, {
    key: "toggle",
    value: function toggle() {
      if (this.playing) {
        this.playing = false;
        this.playlist.pause();
        this.speakerTracks.forEach(function (s) {
          return s.pause();
        });
      } else {
        this.playing = true;
        this.playlist.play();
        this.speakerTracks.forEach(function (s) {
          return s.play();
        });
      }

      return this.playing;
    }
  }]);

  return Mixer;
}();

exports.Mixer = Mixer;